export enum JobProfileType {
	RISK_PROFILE = 'riskProfile',
	EXPOSITION_AREA = 'expositionArea',
}
